// Helper function to determine the appropriate URL based on the current URL

function getUrl(baseUrls) {

    let url = '';
    const Mainurl = window.location.href;
    const domain = new URL(Mainurl).hostname; // Extracts 'cifapi3.smarteweb.com'
    const parts = domain.split(".");
    const target = parts[1]; // 'smarteweb'

    //console.log("Extracted subdomain:", target); // Output: smarteweb

    if (target === 'boxonlogistics') {
        url = baseUrls.production;
    } else if (target === 'smarteweb') {
        url = baseUrls.preproduction;
    } else if (target === 'iblesoft') {
        url = baseUrls.development;
    } else {
        url = baseUrls.local;
    }

    return url;
}


// Define the base URLs for each environment
const baseUrls = {
    DataUrl: {
        production: "https://cifadminportalapi.boxonlogistics.com/api/",
        preproduction: "https://cifapi3.smarteweb.com/api/",
        development: "https://cifservices.iblesoft.com/api/",   // development 
        // local: "https://cifservices.iblesoft.com/api/"
        local: 'https://localhost:44356/api/'
    },
    WebsiteUrl: {
        production: "https://cifexpress.boxonlogistics.com/",
        preproduction: "https://cifexpress.smarteweb.com/",
        development: "https://cifreact.iblesoft.com/",
        local: "http://localhost:3000/"
    },
    reportsUrl: {
        production: "https://ciflogistics.boxonlogistics.com/ASPX/",
        preproduction: "https://cifbackend.smarteweb.com/ASPX/",
        development: "https://cifbackend.iblesoft.com/ASPX/",
        local: "https://cifbackend.iblesoft.com/ASPX/"
    },
    FTP: {
        production: "https://filreplive3.boxonlogistics.com/",
        preproduction: "https://filestage3.smarteweb.com/",
        development: "https://filedev3.iblesoft.com/",
        local: "https://filedev3.iblesoft.com/"
    },
    Invoice: {
        production: "https://ciflogistics.boxonlogistics.com/",
        preproduction: "https://cifbackend.smarteweb.com/",
        development: "https://cifbackend.iblesoft.com/",
        local: "https://cifbackend.iblesoft.com/"
    },
    Joomla: {
        production: "https://ciflivelegacy.boxonlogistics.com/media/com_userprofile/",
        preproduction: "https://cifstaginglegacy.smarteweb.com/media/com_userprofile/",
        development: "https://cifstaginglegacy.smarteweb.com/media/com_userprofile/",
        local: "https://cifstagelegacy.boxonlogistics.com/media/com_userprofile/"
    }

};

// Export the URLs
export const DataUrl = getUrl(baseUrls.DataUrl);
export const WebsiteUrl = getUrl(baseUrls.WebsiteUrl);
export const reportsUrl = getUrl(baseUrls.reportsUrl);
export const FTP = getUrl(baseUrls.FTP);
export const Invoice = getUrl(baseUrls.Invoice);
export const Joomla = getUrl(baseUrls.Joomla);





























// // Helper function to determine the appropriate URL based on the current URL
// function getUrl(baseUrls) {
//     let url = '';
//     const Mainurl = window.location.href;
//     const domain = new URL(url).hostname; // Extracts 'cifapi3.smarteweb.com'
//     const parts = domain.split(".");
//     const target = parts[1]; // 'smarteweb'

//     console.log(target); // Output: smarteweb
//     if (window.location.href.includes('boxonlive')) {
//         url = baseUrls.boxonlive;

//     }
//     else if (window.location.href.includes('managecif3')) {
//         url = baseUrls.boxonstage;
//     }
//     else if (window.location.href.includes('cifreact')) {
//         url = baseUrls.dev;
//     }
//     else {
//         url = baseUrls.default;
//     }
//     return url;
// }


// // Define the base URLs for each environment
// const baseUrls = {
//     DataUrl: {
//         boxonlive: "https://cifapi3.boxonlogistics.com/",
//         boxonstage: "https://cifapi3.smarteweb.com/api/",
//         dev: "https://cifservices.iblesoft.com/api/",   // Dev
//         // default: "https://cifservices.iblesoft.com/api/"
//         default: 'https://localhost:44356/api/'
//     },
//     WebsiteUrl: {
//         boxonlive: "https://managecif3.boxonlogistics.com/",
//         boxonstage: "https://managecif3.smarteweb.com/",
//         dev: "https://cifreact.iblesoft.com/",
//         default: "http://localhost:3000/"
//     },
//     reportsUrl: {
//         boxonlive: "https://reports.boxonlive.net/",
//         boxonstage: "https://cifreports3.smarteweb.com/ASPX/",
//         dev: "https://cifreports.iblesoft.com/ASPX/",
//         default: "https://cifbackend.iblesoft.com/ASPX/"
//     },
//     mapUrl: {
//         boxonlive: "https://maps.boxonlive.net/",
//         boxonstage: "https://mapstage.boxonstage.net/",
//         dev: "http://localhost:3001/",
//         default: "http://localhost:3001/"
//     },
//     FTP: {
//         boxonlive: "https://filreplive3.boxonlogistics.com/",
//         boxonstage: "https://filerepstage.smarteweb.com/attachments/",
//         dev: "https://filedev3.iblesoft.com/",
//         default: "https://filedev3.iblesoft.com/"
//     }
// };

// // Export the URLs
// export const DataUrl = getUrl(baseUrls.DataUrl);
// export const WebsiteUrl = getUrl(baseUrls.WebsiteUrl);
// export const reportsUrl = getUrl(baseUrls.reportsUrl);
// export const mapUrl = getUrl(baseUrls.mapUrl);
// export const FTP = getUrl(baseUrls.FTP);
